import React from 'react';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import GeneralInformationListBlockData from 'Models/Content/GeneralInformationListBlockData';
import GeneralInformationItemBlockData from 'Models/Content/GeneralInformationItemBlockData';
import GeneralInformationItem from './GeneralInformationItem';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';

const GeneralInformationListBlock = (props: ComponentProps<GeneralInformationListBlockData>) => {
  const {
    data: {operationBoxItems, isSquareView},
    context,
  } = props;

  const squareView = isSquareView?.value === true;

  const items = operationBoxItems?.expandedValue?.map(({title, link, image}: GeneralInformationItemBlockData) => ({
    href: link.value,
    title: title.value,
    image: getBackgroundImageProps(image, context),
    isSquareView: squareView,
  }));

  const itemsClassName = squareView
    ? 'GeneralInformationListBlock-items GeneralInformationListBlock-items-square'
    : 'GeneralInformationListBlock-items';

  return React.createElement(
    'div',
    {className: 'GeneralInformationListBlock'},
    React.createElement(
      BlockWrapper as any,
      {props},
      React.createElement(
        'div',
        {className: itemsClassName},
        items?.map((itemsProps, i) => React.createElement(GeneralInformationItem as any, {key: i, ...itemsProps}))
      )
    )
  );
};

export default GeneralInformationListBlock;
